import gql from 'graphql-tag';

export const findDato = gql`
query findDato($uuid: String) {
  findDato(uuid: $uuid) {
    uuid
    esConnection {
      edges {
        node {
          uuid
          codigo
          descripcion
          nombre
          nombre_en
          nombre_es
          nombreCode
          unidad
        }
      }
    }
  }
}`
